var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full_layout cypher", attrs: { id: "cypher" } },
    [
      _c(
        "div",
        { staticClass: "exchangeBigList" },
        [
          _c("div", { staticClass: "userTitle" }, [
            _vm._v(_vm._s(_vm.$t("RedemptionHistory")))
          ]),
          _vm._v(" "),
          !_vm.isNull
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "order_list order_list_title" }, [
                    _c("div", { staticClass: "exchangeCard" }, [
                      _vm._v(_vm._s(_vm.$t("Cards")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "exchangeCardName" }, [
                      _vm._v(_vm._s(_vm.$t("ProductName")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "exchangeTime" }, [
                      _vm._v(_vm._s(_vm.$t("RedemptionDate")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "exchangeAddress" }, [
                      _vm._v(_vm._s(_vm.$t("ShippingAddresses1")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "exchangeStatus" }, [
                      _vm._v(_vm._s(_vm.$t("Status")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "exchangeList" },
                    _vm._l(_vm.list, function(item, index) {
                      return _c("li", { key: index }, [
                        _c(
                          "div",
                          { staticClass: "exchangeCard" },
                          [
                            item.Status == 3
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "expressView",
                                    on: {
                                      click: function($event) {
                                        return _vm.viewExpress(
                                          "viewexpress",
                                          item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("ViewTracking")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-image", {
                              staticClass: "exchangeImage",
                              attrs: {
                                src: item.TitImg + "?imageView2/2/w/350",
                                fit: "fit",
                                "preview-src-list": [item.TitImg]
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "exchangeCardName" }, [
                          _c("p", [_vm._v(_vm._s(item.Title))])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "exchangeTime" }, [
                          _vm._v(_vm._s(item.CreateDate))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "exchangeAddress" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(item.Country) +
                                " " +
                                _vm._s(_vm._f("setProvice")(item.Provice)) +
                                " " +
                                _vm._s(item.AddressDetail) +
                                " " +
                                _vm._s(item.ZipCode) +
                                " " +
                                _vm._s(item.UserName) +
                                " " +
                                _vm._s(item.Mobile)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "exchangeStatus" }, [
                          item.Status == 1
                            ? _c("span", { staticClass: "text_red" }, [
                                _vm._v(_vm._s(_vm.$t("PendingSignature")))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.Status == 2
                            ? _c("span", {}, [
                                _vm._v(_vm._s(_vm.$t("InWarehouse")))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.Status == 3
                            ? _c("span", { staticClass: "text_greed" }, [
                                _vm._v(_vm._s(_vm.$t("Shipped")))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.Status == 4
                            ? _c("span", {}, [
                                _vm._v(_vm._s(_vm.$t("Completed")))
                              ])
                            : _vm._e()
                        ])
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    attrs: { TotalCount: _vm.TotalCount, ps: _vm.ps },
                    on: { ps: _vm.pageSize, pi: _vm.pageIndex }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isNull
            ? _c("nonull", {
                attrs: { type: "order", text: _vm.$t("Norecords") }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.dislogType.viewexpress
            ? _c("to-express", {
                attrs: {
                  title: _vm.$t("TrackingDetails"),
                  list: _vm.viewexpress,
                  domVisible: _vm.dislogType.viewexpress
                },
                on: { closeDialog: _vm.closeDialog }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34195b62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34195b62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cypher/index.vue
// module id = null
// module chunks = 